import { Store, select } from '@ngrx/store';
import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap
} from '@ngrx/store';
import { ProductGroup } from '../../../models/product-group.model';

import * as fromProductGroup from './product-groups.reducer';

export const reducers: ActionReducerMap<any> = {
  // message: fromProductGroup.productGroupReducer
};

export const selectProductGroupState = createFeatureSelector<fromProductGroup.State>('productGroupReducer');


export const { selectAll: selectAllProductGroups } = fromProductGroup.productGroupAdapter.getSelectors(
  selectProductGroupState
);

export const selectAddProductGroupCompleted = createSelector(selectProductGroupState,
  fromProductGroup.getProductGroupStatus
);

export const {
  selectIds: productGroupIds,
  selectEntities: productGroupEntities,
  selectAll: allProductGroups,
  selectTotal: totalProductGroups
} = fromProductGroup.productGroupAdapter.getSelectors(selectProductGroupState);

export const selectProductGroupsByCompanyId = createSelector(
  allProductGroups,
  (productGroups: ProductGroup[], { id }: { id: string }) => productGroups.filter(productGroup => productGroup.companyId === id)
);

export const selectProductGroupsByCompanyIdSiteId = createSelector(
  allProductGroups,
  (productGroups: ProductGroup[], { companyId, siteId }: { companyId: string, siteId: string }) => productGroups.filter(productGroup => productGroup.companyId === companyId && productGroup.siteId === siteId)
);


export const selectAllCourses = createSelector(
  selectProductGroupState,
  categoriesState => {
    const allCourses = Object.values(categoriesState.entities);
    allCourses.sort();
    return allCourses;
  }
);

export interface FeatureState {
  counter: number;
}

export interface AppState {
  feature: FeatureState;
}

export const selectFeature = createFeatureSelector< FeatureState>('feature');

export const selectFeatureCount = createSelector(
  selectFeature,
  (state: FeatureState) => state.counter
);
